import { BriefcaseBusinessIcon, FactoryIcon } from "lucide-react";
import { useNavigate } from "react-router";

import { Column, Row, Text } from "@/components";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { CompanySummary, JobStatus } from "@/types";

export const CompaniesTable = ({
  companies,
}: {
  companies: CompanySummary[];
}) => {
  const navigate = useNavigate();

  const handleRowClick = (company: CompanySummary) => {
    mixpanelUtils.trackRowClick("Company", MIXPANEL_SCREENS.COMPANIES);
    void navigate(company.id);
  };

  return (
    <Column className="overflow-auto">
      <div className="rounded-t-lg border border-b-0 border-slate-200">
        <Table>
          <TableHeader>
            <TableRow className="border-none">
              <TableHead className="w-[80%]">
                <Row className="items-center gap-1">
                  <FactoryIcon className="h-4 w-4 text-slate-700" />
                  <Text variant="header">Company name</Text>
                </Row>
              </TableHead>
              <TableHead className="w-[20%]">
                <Row className="items-center gap-1">
                  <BriefcaseBusinessIcon className="h-4 w-4 text-slate-700" />
                  <Text variant="header">Number of active jobs</Text>
                </Row>
              </TableHead>
            </TableRow>
          </TableHeader>
        </Table>
      </div>
      <div className="overflow-y-auto rounded-b-lg border border-slate-200">
        <Table>
          <TableBody>
            {companies.map((company) => {
              return (
                <TableRow
                  className="cursor-pointer"
                  key={company.id}
                  onClick={() => {
                    handleRowClick(company);
                  }}
                >
                  <TableCell className="w-[80%]">
                    <Text>{company.name}</Text>
                  </TableCell>
                  <TableCell className="w-[20%]">
                    {/* Important to use `<span>` so entire width of cell doesn't get taken. */}
                    <span className="rounded-lg border border-slate-200 p-2 text-slate-700">
                      {
                        company.jobs.filter(
                          (job) => job.status === JobStatus.ACTIVE,
                        ).length
                      }{" "}
                      active jobs
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </Column>
  );
};
